import React from 'react';

import AdminLayout from '../../../components/Layout/AdminLayout';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/jsonMessages';
import ContactInquiriesManagement from './ContactInquiriesManagement';

export default async function action({ store, intl }) {

    const title = intl ? intl?.formatMessage(messages.manageContactInquiries) : 'Contact Us Enquiries';

    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    const adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    const privileges = store.getState().listSettings && store.getState().listSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    if (!restrictUrls('/siteadmin/contact-inquiries', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: <AdminLayout><ContactInquiriesManagement title={title} /></AdminLayout>,
    };
}
